import { imageBuilder } from '@noths/polaris-client-data-builders';
import * as R from 'ramda';

import { Product, ProductSpecialFeatures } from 'src/types';
import { partnerBuilder } from './partner';

const defaults: Readonly<Product> = {
  title: 'Alice and Joe',
  allowsGiftMessage: false,
  allowsGiftReceipt: false,
  allowsGiftWrap: false,
  availability: 'available',
  available: true,
  backInStockAt: null,
  code: 0,
  deliveryOptions: [],
  deliveryByEvent: null,
  description: 'description',
  dimensions: '',
  freeDomesticDelivery: false,
  freeGiftWrap: false,
  images: [imageBuilder()],
  inventoryStatus: 'in_stock',
  isNew: false,
  links: [],
  materials: '',
  breadcrumbCategoryId: '',
  navigation: [],
  numberOfReviews: 0,
  onSale: false,
  options: [],
  ingredients: null,
  otherInformation: '',
  partner: partnerBuilder({ shortcode: 'aliceandjoe', name: 'Alice and Joe' }),
  preSalePrices: [],
  price: { amount: 0, currency: 'GBP' },
  prices: [{ amount: 0, currency: 'GBP' }],
  productRating: null,
  proposedProductTypeId: 0,
  purchasable: true,
  returnsInformation: '',
  salePercentage: 0,
  specialFeatures: {} as ProductSpecialFeatures,
  variationsAvailable: '',
  shippingInfo: null,
};

export const productBuilder = (product: Partial<Product> = {}) =>
  R.mergeDeepRight(defaults, product) as Readonly<Product>;
